import React, { useEffect, useRef, useState } from "react";
import api, { formatApiError } from "../../api";
import { btnGhost, btnPrimary, inputCls, panel } from "./ui";

export function PhotoManager({ student, onChange }) {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) return setErr("La foto supera 5 MB.");
    setBusy(true);
    setErr("");
    const fd = new FormData();
    fd.append("file", file);
    try {
      await api.post(`/students/${student.id}/photo`, fd);
      onChange();
    } catch (ex) {
      setErr(formatApiError(ex));
    } finally {
      setBusy(false);
    }
  };
  const remove = async () => {
    if (!window.confirm("¿Quitar la foto del carnet?")) return;
    await api.delete(`/students/${student.id}/photo`);
    onChange();
  };
  return (
    <div className="mt-4 space-y-2">
      <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={upload} data-testid="eid-photo-input" />
      <div className="flex gap-2">
        <button onClick={() => input.current.click()} disabled={busy} className={btnGhost} data-testid="eid-photo-upload-btn">
          {busy ? "Subiendo…" : student.hasPhoto ? "Cambiar foto" : "Subir foto"}
        </button>
        {student.hasPhoto && <button onClick={remove} className={btnGhost} data-testid="eid-photo-remove-btn">Quitar foto</button>}
      </div>
      <p className="text-[11px] text-[#132C44]/55">Opcional. JPG, PNG o WEBP hasta 5 MB. Privada: no se muestra en el QR público.</p>
      {err && <div className="text-[12px] text-[#9B2C3B]" data-testid="eid-photo-error">{err}</div>}
    </div>
  );
}

export function StudentInfoForm({ student, onSaved }) {
  const [courses, setCourses] = useState([]);
  const [form, setForm] = useState({ firstName: student.firstName, lastName: student.lastName, courseId: student.courseId || "", level: student.level || "" });
  const [msg, setMsg] = useState("");
  useEffect(() => {
    api.get("/courses").then(({ data }) => setCourses(data));
  }, []);
  const save = async (e) => {
    e.preventDefault();
    try {
      const body = { firstName: form.firstName, lastName: form.lastName, level: form.level };
      if (form.courseId) body.courseId = form.courseId;
      await api.patch(`/students/${student.id}`, body);
      setMsg("Guardado.");
      onSaved();
    } catch (ex) {
      setMsg(formatApiError(ex));
    }
  };
  const f = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <form onSubmit={save} className={`${panel} grid sm:grid-cols-2 gap-3 mt-5`} data-testid="eid-student-info-form">
      <input required className={inputCls} value={form.firstName} onChange={f("firstName")} data-testid="eid-info-firstname" />
      <input required className={inputCls} value={form.lastName} onChange={f("lastName")} data-testid="eid-info-lastname" />
      <select className={inputCls} value={form.courseId} onChange={f("courseId")} data-testid="eid-info-course">
        <option value="">Sin curso</option>
        {courses.map((c) => <option key={c.id} value={c.id}>{c.name} · escala {c.scaleMin}–{c.scaleMax}</option>)}
      </select>
      <input className={inputCls} placeholder="Nivel (A1, B1…)" value={form.level} onChange={f("level")} data-testid="eid-info-level" />
      <div className="sm:col-span-2 flex items-center gap-3">
        <button className={btnPrimary} data-testid="eid-info-save">Guardar datos</button>
        {msg && <span className="text-[12px]" data-testid="eid-info-msg">{msg}</span>}
      </div>
    </form>
  );
}
